import { isSSR } from './ssr';

const mockKey = '00000000000';
export const safetyPartnerKey = isSSR ? mockKey : window.API_KEY;

/**
 * Формирует урл для доступа к апи
 * @example https://api.level.travel | https://api.staging-alpha.level.travel | https://api.leveltravel.dev
 */
export const baseUrl = (function getBaseUrl() {
  if (isSSR) return '';

  const [subdomains] = window.location.host.split(window.ENV_DOMAIN);
  const stagging = subdomains
    .split('.')
    .filter((subdomain) => /staging/.test(subdomain))
    .toString();

  const result = ['https://api', stagging, window.ENV_DOMAIN || 'level.travel']
    .filter(Boolean)
    .join('.');

  return result;
})();

export const clientBaseURL: string = (() => {
  if (isSSR) return '';

  return window.location.origin ?? `https://${window.ENV_DOMAIN}`;
})();
